import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FiArrowLeft, FiHome, FiSearch } from "@/lib/icons";
import { broker } from "@/config/broker.config";

export function NotFoundPage() {
  const navigate = useNavigate();

  const quickLinks = [
    { label: "Home Loans", href: "/home-loans", icon: "home" },
    { label: "Calculators", href: "/calculators", icon: "calc" },
    { label: "About Us", href: "/about", icon: "about" },
    { label: "Contact", href: "/contact", icon: "contact" },
  ];

  return (
    <section className="min-h-[80vh] flex items-center justify-center py-16 md:py-24">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        {/* 404 Graphic */}
        <div className="relative mb-8">
          <div className="font-serif text-[150px] md:text-[200px] leading-none font-bold text-muted/30 select-none">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 md:w-24 md:h-24 bg-accent rounded-full flex items-center justify-center animate-bounce">
              <FiSearch className="size-8 md:size-10 text-accent-foreground" />
            </div>
          </div>
        </div>

        {/* Text */}
        <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl mb-4">
          Page not found
        </h1>
        <p className="text-lg text-muted-foreground mb-8 max-w-md mx-auto">
          Looks like this page has moved or doesn't exist. Let's get you back on
          track to finding your perfect home loan.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="btn-pill h-11 px-6"
          >
            <FiArrowLeft className="mr-2 size-4" />
            Go Back
          </Button>
          <Button asChild className="btn-pill h-11 px-6">
            <Link to="/">
              <FiHome className="mr-2 size-4" />
              Back to Home
            </Link>
          </Button>
        </div>

        {/* Quick Links */}
        <div className="bg-cream rounded-2xl p-6 md:p-8">
          <h2 className="font-medium mb-4">Popular pages</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {quickLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="bg-white rounded-xl p-4 text-center hover:shadow-md transition-shadow group"
              >
                <span className="text-sm font-medium group-hover:text-accent transition-colors">
                  {link.label}
                </span>
              </Link>
            ))}
          </div>
        </div>

        {/* Help Text */}
        <p className="mt-8 text-sm text-muted-foreground">
          Need help? Give us a call at{" "}
          <a
            href={`tel:${broker.phone.replace(/\s/g, "")}`}
            className="text-foreground underline hover:text-accent"
          >
            {broker.phone}
          </a>
        </p>
      </div>
    </section>
  );
}
